import uh1 from "./uh-1.jpg";
import uh2 from "./uh-2.jpg";
import uh3 from "./uh-3.jpg";
import uh4 from "./uh-4.jpg";
import uh5 from "./uh-5.jpg";
import uh6 from "./uh-6.jpg";
import uh7 from "./uh-7.jpg";
import uh8 from "./uh-8.jpg";
import uh9 from "./uh-9.jpg";
import uh10 from "./uh-10.jpg";
import uh11 from "./uh-11.jpg";
import uh12 from "./uh-12.jpg";
import uh13 from "./uh-13.jpg";
import uh14 from "./uh-14.jpg";
import uh15 from "./uh-15.jpg";
import uh16 from "./uh-16.jpg";
import uh17 from "./uh-17.jpg";
import uh18 from "./uh-18.jpg";
import uh19 from "./uh-19.jpg";
import uh20 from "./uh-20.jpg";
import uh21 from "./uh-21.jpg";
import uh22 from "./uh-22.jpg";
import uh23 from "./uh-23.jpg";
import uh24 from "./uh-24.jpg";
import uh25 from "./uh-25.jpg";
import uh26 from "./uh-26.jpg";
import uh27 from "./uh-27.jpg";
import uh28 from "./uh-28.jpg";
import uh29 from "./uh-29.jpg";
import uhFp3d from "./uh-fp-3d.jpg";
import uhFp2d from "./uh-fp-2d.jpg";

export const uhrinesImages = [
  uh1, uh2, uh3, uh4, uh5, uh6, uh7, uh8, uh9, uh10,
  uh11, uh12, uh13, uh14, uh15, uh16, uh17, uh18, uh19, uh20,
  uh21, uh22, uh23, uh24, uh25, uh26, uh27, uh28, uh29,
];

export const uhrinesFloorPlans = [
  { image: uhFp3d, label: "Půdorys – 3D" },
  { image: uhFp2d, label: "Půdorys – 2D" },
];
